<template>
    <div class="card p-2 w-100">
        <div class="d-flex">
            <h5 class="mb-2 me-2">
                Tags
                <a
                    tabindex="0"
                    href="javascript:void(0);"
                    role="button"
                    v-custom-popover="{ content: sanitizeMarkup(tagsTooltip) }"
                >
                    <i class="fas fa-info-circle text-primary font-size-xs"></i>
                </a>
            </h5>
        </div>
        <div>
            <div class="form-group">
                <label for="tag-name"> Name </label>
                <input name="tag-name" class="form-control w-40" type="text" v-model="tagName" />
            </div>
            <div class="form-group">
                <label for="tag-description"> Description </label>
                <textarea
                    class="form-control"
                    name="tag-description"
                    id="tag-description"
                    v-model="tagDescription"
                    rows="6"
                    maxlength="5000"
                ></textarea>
            </div>
        </div>
        <div class="footer">
            <button type="button" class="btn btn-primary border border-primary me-2" @click="ok()">Save</button>
            <button type="button" class="btn btn-light border border-secondary" @click="cancel()">Cancel</button>
        </div>
    </div>
</template>

<script lang="ts" src="./NewTag.ts"></script>
